import React from 'react';
// eslint-disable-next-line no-unused-vars
import * as FxLog from '../../../fx/FxLog';
import * as FxFetch from '../../../fx/FxFetch';
import { useTranslation } from '../../../hx/useTranslation';
import CxDialog from '../../../cx/CxDialog';
import CxInput from '../../../cx/CxInput';
import CxSnackbar from '../../../cx/CxSnackbar';
import CxSearcher from '../../../cx/CxSearcher';
import CxDlgAlert from '../../../cx/CxDlgAlert'; // Importación de la alerta
import '../../../../styles/main.css';


const MxLabTechOTF = (props) => {
  const [{ trans }] = useTranslation();
  const [dlg, setDlg] = React.useState(false);
  const [disabled, setDisabled] = React.useState(false);

  const rf_txLabTech = React.useRef(null);
  const rf_txLab = React.useRef(null);
  const rf_txNotes = React.useRef(null);

  const r_dlg_alert = React.useRef(null); // Referencia para el diálogo de espera
  const r_snack_required = React.useRef(null);
  const r_snack_exists = React.useRef(null);

  React.useEffect(() => {
    formLoad();
    // eslint-disable-next-line
  }, []);

  React.useImperativeHandle(props.xref, () => {
    return {
      setDlg,
    };
  });

  const formLoad = async () => {
  }

  const formSave = async () => {
    // Validaciones de requeridos
    if (rf_txLabTech.current.isEmpty()) {
      r_snack_required.current.setVal(trans('field.required') + ": " + rf_txLabTech.current.getLabel());
      r_snack_required.current.setOpen(true);
      return;
    }
    if (rf_txLab.current.isEmpty()) {
      r_snack_required.current.setVal(trans('field.required') + ": " + rf_txLab.current.getLabel());
      r_snack_required.current.setOpen(true);
      return;
    }

    // --- INICIO PROCESO GUARDADO ---
    setDlg(false); // Cerramos ventana principal
    setDisabled(true);

    r_dlg_alert.current.setText(trans('msg.saving'));
    r_dlg_alert.current.setProgressMsg(trans('msg.please_wait'));
    r_dlg_alert.current.setTextColor('var(--ibs_color_blue)');
    r_dlg_alert.current.setHasButtonClose(false);
    r_dlg_alert.current.setOpen(true);

    let txLabTech = rf_txLabTech.current.getVal();
    let inLab = rf_txLab.current.getKey();
    let txNotes = rf_txNotes.current.getVal();

    let record = {};
    record['txLabTech'] = txLabTech;
    record['inLab'] = inLab;
    record['txNotes'] = txNotes;

    Promise.all([FxFetch.doJsonX("lab_techs/otf", record)]).then((result) => {
      r_dlg_alert.current.setOpen(false); // Cerramos cartel de espera

      if (result[0]) {
        if (result[0].theValue === null) {
          // El técnico ya existe, reabrimos ventana
          setDisabled(false);
          setDlg(true);
          r_snack_exists.current.setVal(trans('msg.x_exists','field.lab_tech'));
          r_snack_exists.current.setOpen(true);
        } else {
          // ÉXITO: Sin snackbar, simplemente notificamos al padre y limpiamos
          let inProf = result[0].theValue;
          if (props.onOk) props.onOk(inProf, txLabTech);
          setDisabled(false); 
        }
      }
    }).catch((error) => {
      // Error de red, reabrimos ventana
      r_dlg_alert.current.setOpen(false);
      setDisabled(false);
      setDlg(true);
      FxLog.errorx("MxLabTechOTF.formSave", error);
    });
  }

  return (
    <div>
      <CxDialog title={trans('field.create_x','field.lab_tech')} open={dlg} onOk={formSave} onClose={() => setDlg(false)} >

        <CxInput xref={rf_txLabTech} label={trans('field.lab_tech')} disabled={disabled} width='var(--ibs_control_width_md)' maxLength={100} required />
        
        <CxSearcher xref={rf_txLab} label={trans('field.lab')}
          dbfield="n_lab.txLab" dbfieldkey={`n_lab_tech.inLab`}
          disabled={disabled}
          url="labs"
          col_id="inLab"
          col_tx="txLab"
          columns={[
            { id: "0", Header: "ID", accessor: "inLab", show: false },
            { id: "1", Header: trans('field.lab'), accessor: row => rf_txLab.current.getTable().highlightText(row["txLab"]), width: '100%' },
          ]}
          width='var(--ibs_control_width_md)'
          required
        />

        <CxInput xref={rf_txNotes} label={trans('field.notes')} disabled={disabled} width='var(--ibs_control_width_md)' minRows={4} />

      </CxDialog>

      {/* Alerta de bloqueo/espera */}
      <CxDlgAlert xref={r_dlg_alert} />

      <CxSnackbar xref={r_snack_required} severity="error" />
      <CxSnackbar xref={r_snack_exists} severity="error" />
    </div>
  );

}

export default MxLabTechOTF;